import { dispatch } from 'store';

export const createActionDispatcher = <T>(actionCreator: (payload: T) => any) => {
  return (payload: T) => {
    dispatch(actionCreator(payload));
  };
};
